module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/store_images/2_daf4ba087e1114306b7adc755d2adf9f.png";